<div class="table-responsive">
  <table class="table table-bordered text-center">
    <thead>
      <tr>
        <th class="text-value" *ngFor="let record of data">{{ formatDate(record.date) }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td *ngFor="let record of data">
          <span
            class="status-circle"
            [ngClass]="{
              'status-pass': record.status === 'pass',
              'status-fail': record.status === 'fail',
            }"
          >
            {{ record.status.charAt(0).toUpperCase() }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
